module.exports = __webpack_public_path__ + "img/team-11.bfdfc2d3.jpg";